// @flow

import type { User } from './user';
import type { Order, OrderMessage} from './order';
// import type { Transaction, TransactionMessage } from './transaction';

export type Notification = {
  type: string;
  id: string;
  // formattedName: string;
  read: boolean;
  seen: boolean;
  subtype: NotificationType;
  createdAt: number;
  transmitter: User;
  receiver: User;
  order?: Order;
  //transaction?: Transaction;
  orderMessage?: OrderMessage;
  /* Own impl */
  group?: Notification[];
};

export type NotificationType = $Values<typeof NotificationTypeMap>;

export const NotificationTypeMap = Object.freeze({
  MESSAGE_NEW: 'MESSAGE_NEW',
  PURCHASER_ORDER_PAID: 'PURCHASER_ORDER_PAID',
  PURCHASER_ORDER_PURCHASED: 'PURCHASER_ORDER_PURCHASED',
  PURCHASER_ORDER_RECEIVED: 'PURCHASER_ORDER_RECEIVED',
  PURCHASER_ORDER_CANCELED: 'PURCHASER_ORDER_CANCELED',
  PURCHASER_ORDER_ITEM_CANCELED: 'PURCHASER_ORDER_ITEM_CANCELED',
  PURCHASER_ORDER_RECEIVED_WITH_CANCELLATIONS: 'PURCHASER_ORDER_RECEIVED_WITH_CANCELLATIONS',
  PURCHASER_ORDER_ARRIVED: 'PURCHASER_ORDER_ARRIVED',
  PURCHASER_ORDER_IN_QEMPO_CONFIRMED: 'PURCHASER_ORDER_IN_QEMPO_CONFIRMED',
  PURCHASER_ORDER_SHIPPING: 'PURCHASER_ORDER_SHIPPING',
  PURCHASER_ORDER_DELIVERED: 'PURCHASER_ORDER_DELIVERED',
  PURCHASER_ORDER_RETURNED: 'PURCHASER_ORDER_RETURNED',
  TRAVELER_RESERVATION_EXPIRED: 'TRAVELER_RESERVATION_EXPIRED',
  TRAVELER_ORDER_IN_QEMPO: 'TRAVELER_ORDER_IN_QEMPO',
  TRAVELER_ORDER_SHIPPING: 'TRAVELER_ORDER_SHIPPING',
  TRAVELER_ORDER_DISBURSEMENT_SENT: 'TRAVELER_ORDER_DnoISBURSEMENT_SENT',
});




// WEBPACK FOOTER //
// ./src/entities/notification.js